module.exports = __webpack_public_path__ + "98018264cec55583cdd417520c1157b3.svg";